import { createFileRoute } from '@tanstack/react-router';

import { DashboardView } from '@/platform/dashboard/DashboardView';

export const Route = createFileRoute('/_app/')({
   component: DashboardView
});
